module.exports = __webpack_public_path__ + "img/img_tag_xiangmu.4f9a0626.svg";